var _mask, _path, _mask2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartCost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 222,
    viewBox: "0 0 222 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_49_7380",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.339 110.839C201.339 93.6863 196.465 76.8864 187.283 62.3975C178.101 47.9086 164.991 36.3274 149.48 29.0035C133.969 21.6796 116.697 18.9146 99.6745 21.0308C82.6524 23.1469 66.5823 30.0571 53.3367 40.9559C40.0912 51.8548 30.2159 66.2936 24.8615 82.5895C19.5071 98.8855 18.8942 116.368 23.0942 132.999C27.2941 149.63 36.1341 164.724 48.5838 176.524C61.0335 188.324 76.5802 196.343 93.4123 199.646L110.839 110.839H201.339Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.339 110.839C201.339 93.6863 196.465 76.8864 187.283 62.3975C178.101 47.9086 164.991 36.3274 149.48 29.0035C133.969 21.6796 116.697 18.9146 99.6745 21.0308C82.6524 23.1469 66.5823 30.0571 53.3367 40.9559C40.0912 51.8548 30.2159 66.2936 24.8615 82.5895C19.5071 98.8855 18.8942 116.368 23.0942 132.999C27.2941 149.63 36.1341 164.724 48.5838 176.524C61.0335 188.324 76.5802 196.343 93.4123 199.646L110.839 110.839H201.339Z",
    stroke: "#0945B8",
    strokeWidth: 88,
    mask: "url(#path-1-inside-1_49_7380)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_49_7380",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.4162 198.256C98.8958 201.332 110.869 202.116 122.652 200.565C134.435 199.014 145.797 195.157 156.089 189.215C166.382 183.272 175.403 175.361 182.638 165.932C189.873 156.504 195.18 145.742 198.256 134.263C201.332 122.783 202.116 110.81 200.565 99.0268C199.014 87.2438 195.157 75.8818 189.215 65.5894C183.272 55.297 175.361 46.2758 165.932 39.0409C156.503 31.806 145.742 26.4991 134.262 23.4231L110.839 110.839L87.4162 198.256Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4162 198.256C98.8958 201.332 110.869 202.116 122.652 200.565C134.435 199.014 145.797 195.157 156.089 189.215C166.382 183.272 175.403 175.361 182.638 165.932C189.873 156.504 195.18 145.742 198.256 134.263C201.332 122.783 202.116 110.81 200.565 99.0268C199.014 87.2438 195.157 75.8818 189.215 65.5894C183.272 55.297 175.361 46.2758 165.932 39.0409C156.503 31.806 145.742 26.4991 134.262 23.4231L110.839 110.839L87.4162 198.256Z",
    stroke: "#25C3E0",
    strokeWidth: 88,
    mask: "url(#path-2-inside-2_49_7380)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartCost);
export default __webpack_public_path__ + "static/media/chart-cost.22a4069ab82a8ef5f2c7e9126899bf12.svg";
export { ForwardRef as ReactComponent };